module.exports = __webpack_public_path__ + "img/3.37f82927.jpg";